import { supportsPopover, getFocusableElements, trapFocus } from '../helpers/utilities';

const mobileNavPopup = () => {
	const popover = document.querySelector('#mobile-nav-popup');
	const trigger = document.querySelector('.js-mobile-nav-popup-trigger');
	const closeElem = document.querySelector('.js-mobile-nav-popup-close');

	if (popover) {
		if (trigger) {
			trigger.addEventListener('click', () => {
				popover.classList.add('popover-open');
			});
		}

		if (closeElem) {
			closeElem.addEventListener('click', () => {
				popover.classList.remove('popover-open');
			});
		}
	}
};

const mobileSubmenuPopup = () => {
	const triggers = document.querySelectorAll('.js-mobile-submenu-popup-trigger');
	const closeElems = document.querySelectorAll('.js-mobile-submenu-popup-close');

	if (triggers) {
		triggers.forEach(trigger => {
			trigger.addEventListener('click', () => {
				const popoverID = trigger.getAttribute('popovertarget');
				const popover = document.querySelector(`#${popoverID}`);
				popover.classList.add('popover-open');
			});
		});
	}

	if (closeElems) {
		closeElems.forEach(closeElem => {
			closeElem.addEventListener('click', () => {
				const popovers = document.querySelectorAll('.mobile-nav__submenu');

				if (popovers) {
					popovers.forEach(popover => {
						popover.classList.remove('popover-open');
					});
				}
			});
		});
	}
};

const headerPopoverAda = () => {
	const submenuPopovers = document.querySelectorAll('.js-header-submenu');
	const mobileNavPopover = document.querySelector('#mobile-nav-popup');
	const mobileSubmenuPopovers = document.querySelectorAll('.mobile-nav__submenu');

	// Submenu popovers - add/remove tabindex from links and toggle the aria-expanded attribute on the trigger
	if (submenuPopovers) {
		submenuPopovers.forEach(popover => {
			if (!popover.hasAttribute('popover')) {
				return;
			}
			let focusables = [];
			let firstFocusable;
			let lastFocusable;

			const popoverID = popover.getAttribute('id');
			const trigger = document.querySelector(`[popovertarget="${popoverID}"]`);
			const arrow = trigger ? trigger?.querySelector('svg') : null;
			const links = popover.querySelectorAll('.header__submenu-link');

			popover.addEventListener('toggle', event => {
				if (event.newState === 'open') {
					if (trigger) {
						trigger.setAttribute('aria-expanded', 'true');
						arrow.classList.add('rotate-180');
					}

					if (links) {
						links.forEach(link => {
							link.setAttribute('tabindex', '1');
						});
					}

					focusables = getFocusableElements(popover);
					firstFocusable = focusables[0];
					lastFocusable = focusables[focusables.length - 1];

					// Move focus into the popover
					firstFocusable?.focus();

					// Trap focus
					popover.addEventListener('keydown', e => trapFocus(e, firstFocusable, lastFocusable));
				} else {
					if (trigger) {
						trigger.setAttribute('aria-expanded', 'false');
						arrow.classList.remove('rotate-180');
					}

					if (links) {
						links.forEach(link => {
							link.setAttribute('tabindex', '-1');
						});
					}

					popover.removeEventListener('keydown', e => trapFocus(e, firstFocusable, lastFocusable));

					// Restore focus to trigger
					trigger?.focus();
				}
			});
		});
	}

	// Mobile nav popover - toggle the aria-expanded attribute on the trigger
	if (mobileNavPopover) {
		let focusables = [];
		let firstFocusable;
		let lastFocusable;

		const trigger = document.querySelector(`[popovertarget="mobile-nav-popup`);

		mobileNavPopover.addEventListener('toggle', event => {
			if (event.newState === 'open') {
				if (trigger) {
					trigger.setAttribute('aria-expanded', 'true');
				}

				focusables = getFocusableElements(mobileNavPopover);
				firstFocusable = focusables[0];
				lastFocusable = focusables[focusables.length - 1];

				console.log(focusables);

				// Move focus into the mobileNavPopover
				firstFocusable?.focus();

				// Trap focus
				mobileNavPopover.addEventListener('keydown', e => trapFocus(e, firstFocusable, lastFocusable));
			} else {
				if (trigger) {
					trigger.setAttribute('aria-expanded', 'false');
				}

				mobileNavPopover.removeEventListener('keydown', e => trapFocus(e, firstFocusable, lastFocusable));

				// Restore focus to trigger
				trigger?.focus();
			}
		});
	}

	// Submenu popovers - add/remove tabindex from links and toggle the aria-expanded attribute on the trigger
	if (mobileSubmenuPopovers) {
		mobileSubmenuPopovers.forEach(popover => {
			let focusables = [];
			let firstFocusable;
			let lastFocusable;

			const popoverID = popover.getAttribute('id');
			const trigger = document.querySelector(`[popovertarget="${popoverID}"]`);
			const links = popover.querySelectorAll('.js-mobile-nav-link');

			popover.addEventListener('toggle', event => {
				if (event.newState === 'open') {
					if (trigger) {
						trigger.setAttribute('aria-expanded', 'true');
					}

					if (links) {
						links.forEach(link => {
							link.setAttribute('tabindex', '1');
						});
					}

					focusables = getFocusableElements(popover);
					firstFocusable = focusables[0];
					lastFocusable = focusables[focusables.length - 1];

					// Move focus into the popover
					firstFocusable?.focus();

					// Trap focus
					popover.addEventListener('keydown', e => trapFocus(e, firstFocusable, lastFocusable));
				} else {
					if (trigger) {
						trigger.setAttribute('aria-expanded', 'false');
					}

					if (links) {
						links.forEach(link => {
							link.setAttribute('tabindex', '-1');
						});
					}

					popover.removeEventListener('keydown', e => trapFocus(e, firstFocusable, lastFocusable));

					// Restore focus to trigger
					trigger?.focus();
				}
			});
		});
	}
};

// If popovers are not supported, we need to use our own implementation
if (!supportsPopover()) {
	console.log('Popovers are not supported, using our own implementation');

	// Mobile navigation popup
	mobileNavPopup();
	mobileSubmenuPopup();
}

headerPopoverAda();
